<template>
  <MatchMedia query="(max-width: 768px)" v-slot="{ matches }">
    <BottleShowMobile  v-if="matches" />
    <BottleShowDesktop v-else />
  </MatchMedia>
</template>
 
<script>
  import { MatchMedia } from "vue-component-media-queries";
  import BottleShowMobile from "./BottleShow_Mobile.vue";
  import BottleShowDesktop from "./BottleShow_Desktop.vue";
 
  export default {
    name: 'BottleShow',
    components: {
      MatchMedia,
      BottleShowMobile,
      BottleShowDesktop,
    },
  }
</script> 